const toNumericId = (value) => {
  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : null;
};

const dedupeSeasonIds = (values = []) => {
  const nextIds = [];
  const seenIds = new Set();

  values.forEach((value) => {
    const normalizedValue = toNumericId(value);
    if (normalizedValue === null || seenIds.has(normalizedValue)) {
      return;
    }

    seenIds.add(normalizedValue);
    nextIds.push(normalizedValue);
  });

  return nextIds;
};

const normalizeStringSeasonIds = (value) => {
  if (typeof value !== "string") {
    return [];
  }

  if (!value.includes(",")) {
    return dedupeSeasonIds([value]);
  }

  return dedupeSeasonIds(
    value
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean)
  );
};

export const normalizeSeasonSelectionIds = (value) => {
  if (Array.isArray(value)) {
    return dedupeSeasonIds(value);
  }

  if (typeof value === "string") {
    return normalizeStringSeasonIds(value);
  }

  if (value === null || value === undefined || value === "") {
    return [];
  }

  return dedupeSeasonIds([value]);
};

export const buildSeasonSelectionQueryValue = (value) =>
  normalizeSeasonSelectionIds(value).join(",");

export const readStoredSeasonSelection = ({
  multiKey,
  legacyKey,
  storage = sessionStorage,
}) => {
  try {
    if (multiKey) {
      const storedMultiValue = storage.getItem(multiKey);
      if (storedMultiValue) {
        const parsedMultiValue = JSON.parse(storedMultiValue);
        const normalizedMultiValue = normalizeSeasonSelectionIds(parsedMultiValue);
        if (normalizedMultiValue.length > 0) {
          return normalizedMultiValue;
        }
      }
    }
  } catch (error) {
    // Ignore malformed storage payloads and continue to the legacy key.
  }

  try {
    if (!legacyKey) {
      return [];
    }

    const storedLegacyValue = storage.getItem(legacyKey);
    if (!storedLegacyValue) {
      return [];
    }

    return normalizeSeasonSelectionIds(JSON.parse(storedLegacyValue));
  } catch (error) {
    return [];
  }
};

export const persistSeasonSelection = ({
  multiKey,
  legacyKey,
  seasonIds,
  storage = sessionStorage,
}) => {
  const normalizedSeasonIds = normalizeSeasonSelectionIds(seasonIds);

  if (multiKey) {
    storage.setItem(multiKey, JSON.stringify(normalizedSeasonIds));
  }

  if (legacyKey && normalizedSeasonIds.length > 0) {
    storage.setItem(legacyKey, JSON.stringify(normalizedSeasonIds[0]));
  }

  return normalizedSeasonIds;
};
